/** @type {import('../schema').ProcessDefinition} */
const proracionOcupante = {
  id: "proracion-ocupante",
  name: "Proración por cambio de ocupante",
  category: "personas",
  outcome:
    "Cuando un ocupante sale y otro entra a mitad de mes, cada uno paga los días que ocupó la unidad; el saliente conserva acceso de solo lectura a su histórico.",
  trigger: "El Administrador asigna un nuevo ocupante con effectiveDate.",
  actors: ["Administrador", "Sistema", "Residente"],
  status: "COMPLETO",
  description:
    "Cierre de la tenencia saliente y apertura de la entrante a partir de un effectiveDate, con proración del gasto común por días en el cierre.",
  lanes: [
    { id: "admin", actor: "Administrador" },
    { id: "sys", actor: "Sistema" },
    { id: "res", actor: "Residente" },
  ],
  steps: [
    {
      id: "s1",
      laneId: "admin",
      type: "start",
      label: "Asignación de nuevo ocupante",
      description:
        "El Administrador asigna un nuevo ocupante a la unidad con una effectiveDate.",
      evidence: "src/screens/admin/UnidadDetalle.jsx",
    },
    {
      id: "s2",
      laneId: "sys",
      type: "decision",
      label: "¿Hay ocupante previo?",
      description:
        "Lee el ocupante vigente del slot (owner/tenant).",
      evidence: "functions/identity/core.js:793 (planCambioOcupantes)",
    },
    {
      id: "s3",
      laneId: "sys",
      type: "task",
      label: "Cierre de la tenencia saliente",
      description:
        "dateTo = effectiveDate − 1, endedReason: transfer; si venía de legado sin occupancy, registra cierre retroactivo con fecha centinela.",
    },
    {
      id: "s4",
      laneId: "sys",
      type: "task",
      label: "Acceso de solo lectura del saliente",
      description:
        "Desactiva userbuilding del saliente (no lo borra): pierde la unidad de su lista pero conserva el histórico. accessBlocked opcional para revocar del todo.",
    },
    {
      id: "s5",
      laneId: "sys",
      type: "task",
      label: "Apertura de la tenencia entrante",
      description:
        "Nueva occupancy dateFrom = effectiveDate, active.",
      evidence: "functions/identity/core.js:936 (aplicarPlan)",
    },
    {
      id: "s6",
      laneId: "sys",
      type: "document",
      label: "Proración en el cierre",
      description:
        "Calcula los días de cada ocupante en el mes, resuelve la responsabilidad diaria (inquilino primero; si no, propietario) y reparte el gasto por días.",
    },
    {
      id: "s7",
      laneId: "res",
      type: "end",
      label: "Cada ocupante paga sus días",
      description:
        "Saliente y entrante reciben la deuda prorrateada por los días ocupados; el saliente conserva acceso de solo lectura.",
    },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3", label: "Sí" },
    { from: "s2", to: "s5", label: "No" },
    { from: "s3", to: "s4" },
    { from: "s4", to: "s5" },
    { from: "s5", to: "s6" },
    { from: "s6", to: "s7" },
  ],
};
export default proracionOcupante;
